export default "__VITE_ASSET__D1Ewe7S7__"